module.exports = __webpack_public_path__ + "static/media/logout.0052a987.svg";